export const navlinks = [
  {
    id: 1,
    name: "our company",
    slug: "/about",
  },
  {
    id: 2,
    name: "locations",
    slug: "/locations",
  },
  {
    id: 3,
    name: "contact",
    slug: "/contact",
  },
];
